import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Hint, SpanWrapper, ScreenReaderOnlyLabel, IconSpan, Select, StyledArrowDown, StyledLabel } from "./Dropdown.styles";
var defaultProps = {
    defaultValue: -1
};
var Dropdown = function(_param) {
    var label = _param.label, options = _param.options, icon = _param.icon, title = _param.title, name = _param.name, id = _param.id, disabled = _param.disabled, hint = _param.hint, _design = _param.design, design = _design === void 0 ? "default" : _design, props = _object_without_properties(_param, [
        "label",
        "options",
        "icon",
        "title",
        "name",
        "id",
        "disabled",
        "hint",
        "design"
    ]);
    // handle controlled vs. uncontrolled components when a `value` prop is set
    var additionalProps = _object_spread({}, props);
    if (additionalProps.value && additionalProps.defaultValue) {
        delete additionalProps.defaultValue;
    }
    var compactDesign = design === "compact";
    var Label = compactDesign ? ScreenReaderOnlyLabel : StyledLabel;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(SpanWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        htmlFor: id,
                        children: label
                    }),
                    icon && /*#__PURE__*/ _jsx(IconSpan, {
                        children: icon
                    }),
                    /*#__PURE__*/ _jsxs(Select, _object_spread_props(_object_spread({}, additionalProps), {
                        name: name !== null && name !== void 0 ? name : id,
                        id: id,
                        disabled: disabled,
                        title: label,
                        icon: icon,
                        compact: compactDesign,
                        children: [
                            title && /*#__PURE__*/ _jsx("option", {
                                disabled: true,
                                value: -1,
                                children: title
                            }, -1),
                            options.map(function(param) {
                                var text = param.label, value = param.value;
                                return /*#__PURE__*/ _jsx("option", {
                                    id: "".concat(id !== null && id !== void 0 ? id : "dropdown", "_").concat(value),
                                    value: value,
                                    children: text
                                }, "".concat(id !== null && id !== void 0 ? id : "dropdown", "_").concat(value));
                            })
                        ]
                    })),
                    /*#__PURE__*/ _jsx(StyledArrowDown, {})
                ]
            }),
            hint && /*#__PURE__*/ _jsx(Hint, {
                children: hint
            })
        ]
    });
};
Dropdown.defaultProps = defaultProps;
export { Dropdown };
